import { defineStore } from "pinia";

export type Theme = "light" | "dark";

export const useThemeStore = defineStore("theme", {
  state: () => ({ theme: "dark" as Theme }),
  actions: {
    initialize() {
      const stored = localStorage.getItem("isypos-theme") as Theme | null;
      const preferred: Theme = "dark";
      this.setTheme(stored ?? preferred);
    },
    setTheme(theme: Theme) {
      this.theme = theme;
      document.documentElement.classList.toggle("dark", theme === "dark");
      localStorage.setItem("isypos-theme", theme);
    },
    toggle() {
      this.setTheme(this.theme === "dark" ? "light" : "dark");
    },
  },
});
